<template>
  <div class="block-shipping-status-history">
    <h4 v-translate>Status History</h4>
    <ul class="p-0" :class="!withElapsed ? 'pt-3' : ''">
      <li class="row" v-if="withElapsed">
        <b-col cols="8">
          <dl>
            <dt v-translate>Status</dt>
          </dl>
        </b-col>
        <b-col cols="4">
        <dl>
          <dt v-translate>Elapsed Time</dt>
        </dl>
        </b-col>
      </li>
      <li v-for="(status, index) in statusHistoryToShow" :key="status.status + index" class="row" :class="status.status.toLowerCase()">
        <b-col cols="8" :class="(status.status === 'DELIVERED') ? 'text-success' : (status.status === 'INCIDENCE' || status.status === 'TOBERETURNED' ? 'text-warning' : (status.status === 'CANCELED' || status.status === 'RETURNED' ? 'text-danger' : ''))">
          <dl>
            <dd>{{statusHistoryToShow.length - index}}. {{ statusStringsByType[status.status] }} <small v-if="status.created_at">({{moment.utc(status.created_at).tz($tz).format('L LT')}})</small></dd>
            <dt v-if="status.details && status.details.reason">
              <small v-if="status.details && status.details.reason" class="d-block">
                <translate>Incidence type</translate>:
                <span class="bg-warning text-dark">&nbsp;{{statusReasonsStrings[status.details.reason] || status.details.reason}}&nbsp;</span>
                <span class="text-dark" style="vertical-align: sub; cursor: pointer" v-b-modal.modalShowPicture @click="currentPicture = status.details.picture || status.details.shippingPhoto.url" v-if="status.details.picture || status.details.shippingPhoto">
                  <font-awesome-icon :icon="['far', 'image']" size="2x" />
                </span>
              </small>
            </dt>
          </dl>
        </b-col>
        <b-col cols="4" v-if="withElapsed">
        <dl>
          <dd>{{elapsedTime(statusHistoryToShow[index].created_at, (index === 0 ? moment.utc().format('YYYY-MM-DD HH:mm:ss') : statusHistoryToShow[index - 1].created_at))}}</dd>
        </dl>
        </b-col>
      </li>
    </ul>
    <b-modal id="modalShowPicture" ref="modalShowPicture" size="lg" :hide-footer="true" @hidden="currentPicture = ''">
      <div slot="modal-title" v-translate>View picture</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <div class="w-100">
        <img :src="currentPicture" alt="" class="w-100">
      </div>
    </b-modal>
  </div>
</template>

<script>
import constants from '@/common/constants'

export default {
  data() {
    return {
      statusHistoryToShow: [],
      currentPicture: '',
      visits: 0,
      statusStringsByType: {}
    }
  },
  props: {
    shipping: {
      type: Object,
      required: true
    },
    withElapsed: {
      type: Boolean,
      default: false
    },
    faked: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    shipping: function (val) {
      this.statusHistoryToShow = this.faked ? this.fakeHistory() : this.shipping.status_history
    }
  },
  mixins: [constants],
  created() {
    this.statusHistoryToShow = this.faked ? this.fakeHistory() : this.shipping.status_history
  },
  mounted () {
    this.statusStringsByType = this.shipping.shipping_type.name !== 'reverse' ? this.statusStrings.normal : this.statusStrings.reverse
    this.$frontConfig = this.shipping.address_to ? window.countries.find(x => x.iso_code === this.shipping.address_to.country).front_config : this.$frontConfig
    this.$frontConfig.i18n.tz = this.$tz = this.$cookies.get('bypassCountry') || !this.$frontConfig.i18n.tz ? 'UTC' : this.$frontConfig.i18n.tz
  },
  methods: {
    fakeHistory() {
      let statusHistoryToShow = []
      let statusStep
      if (this.shipping.status === 'READY' && this.shipping.tour_id !== null) {
        statusHistoryToShow.push({
          status: 'PROGRAMMED',
          created_at: null
        })
      }
      for (let x = 0; x < this.shipping.status_history.length; x++) {
        if (this.shipping.status_history[x].status !== statusStep) {
          statusHistoryToShow.push(this.shipping.status_history[x])
        }
        statusStep = this.shipping.status_history[x].status
      }
      if (statusHistoryToShow.findIndex(x => x.status === 'DRAFT') === -1) {
        statusHistoryToShow.push({
          status: 'DRAFT',
          created_at: this.shipping.created_at
        })
      }
      return statusHistoryToShow
    },
    elapsedTime(from, to) {
      const deliveredAtDate = new Date(Date.parse(to.replace(/-/g, '/')))
      const pickedupAtDate = new Date(Date.parse(from.replace(/-/g, '/')))
      const diffMs = (deliveredAtDate - pickedupAtDate)
      const diffDays = Math.floor(diffMs / 86400000)
      const diffHrs = Math.floor((diffMs % 86400000) / 3600000)
      const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000)
      return (diffDays > 0 ? diffDays + 'd ' : '') + (diffHrs > 0 ? diffHrs + 'h ' : '') + (diffMins > 0 ? diffMins + 'm ' : '0m')
    }
  }
}
</script>
